import React from 'react';
import { Carousel, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import b2Image from '../images/EducateaChild.jpg';
import b3Image from '../images/SkillDevelopmentt.jpg';
import b4Image from '../images/NGO-First-Work.jpg';

const HomeSlider: React.FC = () => {
  return (
    <Carousel fade className="mt-5 custom-carousel" interval={6000} pause="hover">
      <Carousel.Item>
        <div className="carousel-overlay">
          <img
            className="d-block w-100"
            src={b2Image}
            alt="Children supported through Srisailam Foundation programs"
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />
          <div className="carousel-content">
            <h1>Free Education for All</h1>
            <p>Empowering youth through schools, colleges, and skill centers.</p>
            <Link to="/donate/">
              <Button variant="danger" className="me-2">
                Donate Now
              </Button>
            </Link>
            <Link to="/education/">
              <Button variant="outline-light">Learn More</Button>
            </Link>
          </div>
        </div>
      </Carousel.Item>

      <Carousel.Item>
        <div className="carousel-overlay">
          <img
            className="d-block w-100 desktop-focus-image"
            src={b4Image}
            alt="Community outreach event by Srisailam Foundation"
            loading="lazy"
            decoding="async"
          />
          <div className="carousel-content">
            <h1>Free Education: A Road to Equality</h1>
            <p>Helping underprivileged youth build a better future through education.</p>
            <Link to="/donate/">
              <Button variant="danger" className="me-2">
                Donate Now
              </Button>
            </Link>
            <Link to="/education/">
              <Button variant="outline-light">Learn More</Button>
            </Link>
          </div>
        </div>
      </Carousel.Item>

      <Carousel.Item>
        <div className="carousel-overlay">
          <img
            className="d-block w-100"
            src={b3Image}
            alt="Youth learning practical livelihood skills"
            loading="lazy"
            decoding="async"
          />
          <div className="carousel-content">
            <h1>Skill Development</h1>
            <p>Building a skilled future with vocational training.</p>
            <Link to="/donate/">
              <Button variant="danger" className="me-2">
                Donate Now
              </Button>
            </Link>
            <Link to="/livelihood/">
              <Button variant="outline-light">Learn More</Button>
            </Link>
          </div>
        </div>
      </Carousel.Item>
    </Carousel>
  );
};

export default HomeSlider;
